import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { useIsHydrated } from 'hooks/use-is-hydrated';
import { nftUrlParams } from 'schemas/url/nft';

import { NftFilters } from 'types/Nft';

import { FilterStateFn } from './use-nft-filters';

export function useNftFiltersUrlSync(options: {
  filters: NftFilters;
  setFilters: FilterStateFn;
}) {
  const router = useRouter();
  const hasParsedUrlParams = useRef(false);
  const isHydrated = useIsHydrated();

  useEffect(() => {
    if (!hasParsedUrlParams.current || !isHydrated) return;
    nftUrlParams.set(options.filters);
  }, [options.filters]);

  useEffect(() => {
    // Return early if router is not ready, or page is not hydrated
    if (!router.isReady || !isHydrated) return;

    const urlFilters = nftUrlParams.get(router.query);

    if (urlFilters) {
      const cleanedUrlFilters = Object.fromEntries(
        Object.entries(urlFilters).filter(([_, value]) => value !== null)
      );

      options.setFilters({
        ...options.filters,
        ...cleanedUrlFilters,
      });
    } else {
      options.setFilters(options.filters);
    }

    hasParsedUrlParams.current = true;
  }, [router.isReady, isHydrated]);

  return null;
}
